import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ActionConfig } from '../../interfaces/action-config';
import { NgFor } from '@angular/common';
import { RowActionComponent } from './row-action/row-action.component';

@Component({
  selector: 'app-row-actions',
  standalone:true,
  imports:[NgFor,RowActionComponent],
  templateUrl: './row-actions.component.html',
  styleUrls: ['./row-actions.component.scss'],
})
export class RowActionsComponent {
  @Input() rowData: Record<string, any> = {};
  @Input() actions: Array<ActionConfig | ((row: Record<string, any>) => ActionConfig)> = [];
  @Output() onActionClick: EventEmitter<{ name: string; data: any }> = new EventEmitter();

  onActionClicked(props: { name: string; data: any }) {
    this.onActionClick.emit(props);
  }
}
